import { InputVariant } from "components/form/types";

export const INPUT_VARIANT: InputVariant = "outlined";
